import { render } from "./PushScheduleSetting.vue?vue&type=template&id=11656a88&scoped=true"
import script from "./PushScheduleSetting.vue?vue&type=script&lang=ts"
export * from "./PushScheduleSetting.vue?vue&type=script&lang=ts"

import "./PushScheduleSetting.vue?vue&type=style&index=0&id=11656a88&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11656a88"

export default script
import QList from 'quasar/src/components/item/QList.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QSelect,QInput,QField});
